module.exports = __webpack_public_path__ + "img/08_DSC7755-min.72b4c0d6.jpg";